export const VERSION = 'V2.6.37'
// 腾讯地图key
export const QQMAP_KEY = '4AJBZ-UK43W-LJ3RU-O2N4R-BVYL3-NZFOX'
